/** The render context in the browser: one module-scope slot. */
import { ContextError, type RenderContext } from './types';

let active: RenderContext | null = null;

export function runWithContext<T>(ctx: RenderContext, fn: () => T): T {
  const previous = active;
  active = ctx;
  try {
    return fn();
  } finally {
    active = previous;
  }
}

export function currentContext(): RenderContext | null {
  return active;
}

export function renderContext(): RenderContext {
  if (!active) throw new ContextError('No render context is active; call runWithContext first');
  return active;
}

/**
 * The address of the page being built. In the browser that is the page the
 * person is on; the server's build says the address it is rendering, so a
 * component can read its query string on either side.
 */
export function pageUrl(): URL {
  return new URL(window.location.href);
}

export * from './gate';
export * from './types';
